import { connect } from 'react-redux';
import { getVillageId, getCountrysideBuilderLandingPromoData } from '../../selectors';
import { IState } from '../../store';
import {
  CountrysideBuilderProjectsBlock,
  ICountrysideBuilderProjectsBlockProps,
} from './CountrysideBuilderProjectsBlock';

export function mapStateToProps(state: IState): ICountrysideBuilderProjectsBlockProps {
  const villageId = getVillageId(state);
  const data = villageId && getCountrysideBuilderLandingPromoData(state, villageId);

  return {
    offerId: state.offerData.offer.id,
    projectBlock: (data && data.projectBlock) || null,
  };
}

export const CountrysideBuilderProjectsBlockContainer = connect<ICountrysideBuilderProjectsBlockProps>(mapStateToProps)(
  CountrysideBuilderProjectsBlock,
);
